module.exports = __webpack_public_path__ + "media/images/flags/64/Ethiopia-96b4f34557348a7231af2d59a529b963.png";